// @Version: 1.0.4
import { Component, forwardRef, EventEmitter, Output, Input, OnDestroy, SimpleChanges, OnChanges } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator, FormControl, FormBuilder } from "@angular/forms";
import { UntilDestroy } from '@ngneat/until-destroy';
import { IFieldItem } from '../field-item.model';
import { TransformItemService } from './transform-item.service';
import { TRANSLATE_PATH } from 'src/app/shared/shared.model';
import { ErrorMessagesService } from 'src/app/shared/services/errorMessages/error-messages.service';
import { Subscription } from 'rxjs';


@UntilDestroy()
@Component({
   selector: 'app-field-item-download-button',
   templateUrl: './download-button.component.html',
   providers: [
      {
         provide: NG_VALUE_ACCESSOR,
         useExisting: forwardRef(() => FieldItemDownloadButtonComponent),
         multi: true
      },
      {
         provide: NG_VALIDATORS,
         useExisting: forwardRef(() => FieldItemDownloadButtonComponent),
         multi: true
      },
      ErrorMessagesService
   ],
   standalone: false
})

export class FieldItemDownloadButtonComponent implements OnChanges, ControlValueAccessor, Validator, OnDestroy {

   public TRANSLATE_PATH = TRANSLATE_PATH; 

   public fcDownloadButton: FormControl = this.fb.control("");

   private fieldItem_: IFieldItem = {};
   private downloadColors_: string[] = [];
   private downloadIcons_: string[]= [];
   private sub_?: Subscription;

   @Input()
   set fieldItem (value: IFieldItem) {
      this.fieldItem_ = value ?? {};
   }
   get fieldItem (): IFieldItem {
      return this.fieldItem_;
   }
   
   @Output() isRequiredMarker = new EventEmitter<boolean>();

   get colorSuccess (): string {
      return this.downloadColors_[1];
   }

   get colorDefault (): string {
      return this.downloadColors_[0];
   }
   get iconSuccess (): string {
      return this.downloadIcons_[1];
   }

   get iconDefault (): string {
      return this.downloadIcons_[0];
   }

   constructor (public sTransformItem: TransformItemService, private fb: FormBuilder) {}

   ngOnChanges (changes: SimpleChanges): void {
   if (changes && changes.fieldItem &&  (JSON.stringify(changes.fieldItem.currentValue) != JSON.stringify(changes.fieldItem.previousValue))) {
         
      this.downloadColors_ = this.sTransformItem.transform(changes.fieldItem.currentValue.attribute_1);
      this.downloadIcons_ = this.sTransformItem.transform(changes.fieldItem.currentValue.attribute_3);
   
      if (this.sub_) {
         this.sub_.unsubscribe();
         this.sub_ = undefined;
      }
      this.fcDownloadButton.setValue(this.formatContent(changes.fieldItem.currentValue.content));
      this.sub_ = this.fcDownloadButton.valueChanges.subscribe(() => {
         if (!this.value && this.fcDownloadButton.pristine) return;
         this.onChange(this.value);
         this.onTouched();
      });  
      this.isRequiredMarker.emit(changes.fieldItem.currentValue.required);
      }
   }


   ngOnDestroy (): void {
      this.fcDownloadButton = this.fb.control("");
      this.fieldItem_ = {};
      this.downloadColors_ = [];
      this.downloadIcons_ = [];
   }

   validate (control: AbstractControl): ValidationErrors | null {
      this.fcDownloadButton.updateValueAndValidity({emitEvent: false, onlySelf: true});
      return !this.fcDownloadButton.dirty && this.fieldItem.required ? {noDownload: true} : null; 
   }

   registerOnValidatorChange? (fn: () => void): void {
      this.onValidationChange = fn;
   }

   get value (): boolean {
      return this.fcDownloadButton.dirty ? true : false;
   }

   writeValue (input: boolean | undefined | null): void {
      const value = this.formatContent(input);
      this.fcDownloadButton.setValue(value ? value : "");
      if (value) this.setDirtyTouched();
      this.onValidationChange();
   }

   private formatContent (input: boolean | string | undefined | null): boolean {
      return typeof input == "string" && input == "true" ? true : typeof input == 'boolean' ? input : false;
   }

   private setDirtyTouched (): void {
      this.fcDownloadButton.markAsDirty(); 
      this.fcDownloadButton.markAsTouched();
   }
 
   private onTouched () {}

   private onChange (_: boolean) {}

   registerOnChange (fn: any): void {     
     this.onChange = fn
   }

   registerOnTouched (fn: any): void { this.onTouched = fn; }

   onValidationChange: any = () => {};
   
   public onKeyboardEnter () {
      this.fcDownloadButton.markAsDirty();
      this.fcDownloadButton.markAsTouched();
      this.onChange(this.value)
   }
}